'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialBitcoinOutline = function IoSocialBitcoinOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.9 3.8h-0.6v5h-5v-5h-0.8v5h-6.8v1.2h1c0.8 0 1.5 0 1.9 0.2s0.8 0.6 1.1 1.1 0.2 0.6 0.2 1.5v13.9c0 0.9 0 1.4-0.2 1.9v0.1c-0.1 0.2-0.4 0.8-1 1.1h-0.1c-0.3 0.2-0.6 0.2-1.3 0.2h-1l-0.2 1.3h6.4v5h0.8v-5h5v5h0.6v-5.1h1.1c1.8-0.1 3.3-0.4 4.3-0.8 1.3-0.5 2.2-1.2 2.9-2 0.7-0.9 1-2.3 1.1-3.3 0-1.1-0.1-2.3-0.4-2.8s-0.6-1.3-1.6-1.8c-0.5-0.3-1.1-0.5-1.6-0.7l-3.6-0.8 3.3-1.5c0.3-0.2 0.6-0.3 1-0.7 0.4-0.4 0.7-0.9 0.8-1.3 0.2-0.3 0.3-1 0.3-1.7-0.1-1.3-0.4-2.2-0.8-2.9-0.6-0.7-1.4-1.2-2.5-1.6-0.9-0.4-1.8-0.6-3.2-0.6l-1.1-0.1v-4.8z m1.2-1.3v4.9c1.6 0.1 2.5 0.3 3.5 0.7 1.3 0.5 2.3 1.2 3 2.1s0.9 2.2 1 3.6c0.1 0.7 0 1.5-0.2 2.1s-0.6 1.3-1.3 1.8c-0.4 0.5-0.8 0.7-1.2 0.9 0.7 0.2 1.3 0.5 1.9 0.8 1.2 0.6 1.9 1.4 2.3 2.3 0.3 0.8 0.5 2.4 0.4 3.5-0.1 1.2-0.5 2.8-1.2 3.9-0.9 1.1-2.1 1.9-3.6 2.5-1.1 0.4-2.5 0.7-4.6 0.8v5.1h-3.1v-5h-2.5v5h-3.2v-5h-6.8l0.6-3.7h2.2c0.7 0 0.6-0.1 0.9-0.2s0.3-0.2 0.4-0.5 0-0.7 0-1.4v-13.9c0-0.7 0-0.8 0-0.9s-0.3-0.3-0.5-0.5-0.7-0.2-1.4-0.2h-2.2v-3.7h6.8v-5h3.2v5h2.5v-5h3.1z m-3.1 9.2v5.8h-2.5v-5.8h2.5z m0 9.6v7h-2.5v-7h2.5z m3.1-9.3c0.5 0.2 0.8 0.6 1.1 1 0.3 0.4 0.5 1 0.5 1.6s-0.2 1.2-0.6 1.7c-0.3 0.3-0.5 0.7-1 0.9v-5.2z m0 9.4c0.4 0.1 0.7 0.1 1 0.2 0.6 0.3 1.1 0.6 1.4 1.1s0.7 1.1 0.7 1.8c0 0.9-0.2 1.5-0.8 2.1s-1 0.8-1.8 1.1c-0.2 0.1-0.3 0-0.5 0.1v-6.4z' })
        )
    );
};

exports.default = IoSocialBitcoinOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-bitcoin-outline.js
// module id = 2654
// module chunks = 0